import { api } from 'app/api/client';
import { routes } from './requests';

const pathwayApi = {
  activate(pathwayId: string): Promise<void> {
    return api.get<void>(routes.pathways.activate(pathwayId));
  },
};

export { pathwayApi };